import {
  PULSE_CLICK_ACTION,
  PULSE_CLICK_CATEGORY,
  trackCustomerPageClick,
  trackPulseClick,
} from './pulseClickIds';
import { PULSE_VIEW_ID } from './pulseViewIds';

/** Profile Payments / Gift Cards tab — add credit or gift card CTA. */
export const trackAddPaymentMethodClick = (
  view_id: string,
  page_path?: string
): void => {
  trackCustomerPageClick({
    action: PULSE_CLICK_ACTION.TAP_ADD_PAYMENT_METHOD,
    label: null,
    view_id,
    page_path,
  });
};

/** Profile → Payments — remove payment method CTA. */
export const trackDeletePaymentMethodClick = ({
  payment_method_id,
  page_path,
}: {
  payment_method_id: string | number;
  page_path?: string;
}): void => {
  trackPulseClick({
    category: PULSE_CLICK_CATEGORY.CUSTOMER_PAGE,
    action: PULSE_CLICK_ACTION.TAP_DELETE_PAYMENT_METHOD,
    label: null,
    view_id: PULSE_VIEW_ID.PROFILE_PAYMENTS,
    page_id: PULSE_CLICK_CATEGORY.CUSTOMER_PAGE,
    page_path,
    additional_params: { payment_method_id },
  });
};
